/* 审核列表 */
import React, { useState, useEffect } from 'react'
import { Input, Button, Table, message, Select, Pagination, Spin } from 'antd';
import { SearchOutlined , UndoOutlined } from '@ant-design/icons';
import { listCourse, listCourseExport, recommendCourse } from "../../../../http/modules/province";
import { courseCategoryList } from '../../../../http/modules/organization'
import ReviewWorks from '../oeuvre/reviewWorks'
import daoChu from '../../../../img/daoChu.svg'
import './index.scss'
const { Search } = Input;

export default function Index() {

  const [selectionType, setSelectionType] = useState('checkbox');
  // 作品数量  分页器总数
  const [number, setNumber] = useState(0)
  // 已审核数量
  const [audited, setAudited] = useState(0)
  // 未审核数量
  const [unreviewed, setUnreviewed] = useState(0)
  // 推荐作品数量
  const [recommend, setRecommend] = useState(0)
  // table 数据
  const [playerlist, setPlayerlist] = useState()
  // 参赛作品id
  const [playerId, setPlayerId] = useState()
  // 分页器  当前页数
  const [current, setCurrent] = useState(1)
  // 课程类别选择
  const [categorySelect, setCategorySelect] = useState()
  // 搜索内容
  const [search, setSearch] = useState()
  // 评审状态选择
  const [auditStateSelect, setAuditStateSelect] = useState()
  //全部课程类别
  const [categoryList, setCategoryList] = useState([])
  // 审核作品页面展示
  const [reviewWorks, setReviewWorks] = useState(false)
  // loding
  const [loading, setLoading] = useState(false)

  // 搜索按钮
  const onSearch = async (value) => {
    onListCourse(1, '', '', value)
  };

  // Table 选中
  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    },
    getCheckboxProps: (record) => ({
      disabled: record.name === 'Disabled User',
      name: record.name,
    }),
  };

  // table格式
  const columns = [
    {
      title: '授课人',
      dataIndex: 'playerName',
      key: 'playerName',
      className: 'table'
    },
    {
      title: '申报单位',
      dataIndex: 'orgName',
      key: 'orgName',
      className: 'table',
      ellipsis: true,
      width: 230
    },
    {
      title: '课程名称',
      dataIndex: 'title',
      key: 'title',
      className: 'table',
      ellipsis: true,
      width: 230
    },
    {
      title: '课程类别',
      dataIndex: 'category',
      key: 'category',
      className: 'table'
    },
    {
      title: '授课类型',
      dataIndex: 'typ',
      key: 'typ',
      className: 'table'
    },
    {
      title: '评审状态',
      dataIndex: 'provinceAudit',
      key: 'provinceAudit',
      className: 'table'
    },
    {
      title: '合规性审查',
      dataIndex: 'provinceHegui',
      key: 'provinceHegui',
      className: 'table'
    },
    {
      title: '作品分数',
      dataIndex: 'provinceScore',
      key: 'provinceScore',
      className: 'table'
    },
    {
      title: '操作',
      dataIndex: '',
      key: '',
      className: 'table',
      ellipsis: true,
      width: 140,
      render: (event) => (
        <>
          <span style={{ color: '#1F78FE', cursor: 'pointer', marginRight: '16px' }} onClick={() => { setPlayerId(event.courseUUID); setReviewWorks(true) }}>
            审核
          </span>
          {event.provinceRecommend == 0 ? <span style={{ color: '#1F78FE', cursor: 'pointer' }} onClick={() => {event.provinceHegui=='通过'?onRecommend(event.courseUUID, 'yes'):message.error('合规性审核未通过')}}>
            推荐
          </span> :
            <span style={{ color: '#1F78FE', cursor: 'pointer' }} onClick={() => onRecommend(event.courseUUID, 'no')}>
              取消推荐
            </span>
          }
        </>
      )
    }
  ];

  // 分页器点击回调
  const onPagination = (page) => {
    onListCourse(page, categorySelect, auditStateSelect, search)
  }

  //课程类别
  const onCourseCategoryList = async () => {
    const res = await courseCategoryList({})
    setCategoryList(res.data?.list)
  }

  // 课程列表
  const onListCourse = async (page, category = '', auditState = '', searchTxt = '') => {
    setLoading(true)
    try {
      const res = await listCourse({
        "pageNo": page,
        "pageSize": 10,
        "category": category, // 课程类别
        "auditState": auditState, // 评审状态
        "searchTxt": searchTxt // 课程名称 授课人 申报单位 搜索
      });
      if (res.code == 0) {
        setCurrent(res.data.pageNo)
        setNumber(res.data.total)
        setAudited(res.data.cntProvinceAuditYes)
        setUnreviewed(res.data.cntProvinceAuditNo)
        setRecommend(res.data.cntProvinceRecommend)
        let arr = res.data.list
        if (!arr) {
          setPlayerlist()
          setLoading(false)
          return
        }
        arr.map((item) => {
          if (item.provinceAudit == 1) {
            item.provinceAudit = '已评审'
            item.key = item.courseUUID
          } else {
            item.provinceAudit = '未评审'
            item.key = item.courseUUID
          }
          return item
        })
        setLoading(false)
        setPlayerlist(arr)
      }
    } catch (err) {
      setLoading(false)
      message.error(err.response.data?.msg);
    }
  };

  // 推荐
  const onRecommend = async (id, recommends) => {
    setLoading(true)
    try {
      if (recommend < 300 || recommends == 'no') {
        const res = await recommendCourse({
          "courseUUID": id,
          "recommend": recommends // yes推荐 no取消推荐
        });
        if (res.code == 0) {
          message.success('操作成功！')
          onListCourse(current, categorySelect, auditStateSelect, search)
          setLoading(false)
        } else {
          message.error('操作失败！');
          setLoading(false)
        }
      } else {
        message.error('最多推荐300个作品')
      }
    } catch (err) {
      message.error(err.response.data?.msg);
      setLoading(false)
    }
  }

  // 导出
  const derive = async () => {
    setLoading(true)
    try {
      const res = await listCourseExport({
        "pageNo": current,
        "pageSize": 12,
        "category": categorySelect,
        "auditState": auditStateSelect,
        "searchTxt": ""
      });
      if (res) {
        const blob = new Blob([res]);
        const url = window.URL.createObjectURL(blob);
        const temp = document.createElement('a');// 创建a标签
        temp.href = url;
        temp.download = `审核列表.xlsx`;
        temp.click();
        window.URL.revokeObjectURL(url);// 释放内存
        message.success('导出成功！')
        setLoading(false)
      } else {
        message.error('导出失败！');
        setLoading(false)
      }
    } catch (err) {
      message.error(err.response.data?.msg);
      setLoading(false)
    }
  }

  useEffect(() => {
    onCourseCategoryList()
    onListCourse(1)
  }, [])

  return (
    <Spin spinning={loading}>
      {reviewWorks ? <ReviewWorks setReviewWorks={setReviewWorks} reviewWorksId={playerId} /> :
        <div className='auditList'>
          <header>
            <Search
              value={search}
              placeholder="请输入课程名称/授课人/申报单位"
              allowClear
              enterButton="搜索"
              size="large"
              onChange={(e) => setSearch(e.target.value)}
              onSearch={onSearch}
            />
            <div className='headerButton'>
              <Button shape="round" onClick={() => derive()}  size={'large'}>
                <img src={daoChu} alt="" /> 导出
              </Button>
            </div>
          </header>
          <div className='filter'>
            <p>
              课程类别：
              <Select
                value={categorySelect}
                defaultValue="全部"
                style={{ width: 300 }}
                onChange={(value) => setCategorySelect(value)}
                options={categoryList.map(item => ({ value: item.name, label: item.name }))}
              />
            </p>
            <p>
              评审状态：
              <Select
                value={auditStateSelect}
                defaultValue="全部"
                style={{ width: 300 }}
                onChange={(value) => setAuditStateSelect(value)}
                options={[
                  {
                    value: '已评审',
                    label: '已评审',
                  },
                  {
                    value: '未评审',
                    label: '未评审',
                  }
                ]}
              />
            </p>
            <p>
              <Button onClick={() => { onListCourse(1, categorySelect, auditStateSelect, search) }} type="primary" shape="round" icon={<SearchOutlined  />} size={'large'}>
                查询
              </Button>
              <Button onClick={() => { setCategorySelect('全部'); setAuditStateSelect('全部'); onListCourse(1) }} style={{ background: '#FFFFFF', color: '#1F78FE' }} type="primary" shape="round" icon={<UndoOutlined />} size={'large'}>
                重置
              </Button>
            </p>
          </div>
          <div className='tongJi'>
            <p>共有 <span>{number}</span> 个作品</p>
            <p>已评审 <span>{audited}</span> 个作品</p>
            <p>未评审 <span>{unreviewed}</span> 个作品</p>
            <p>推荐 <span>{recommend}</span> 个作品</p>
          </div>
          <main>
            <Table rowSelection={{ type: selectionType, ...rowSelection, }}
              dataSource={playerlist} columns={columns} pagination={false} />;
          </main>
          <footer>
            <Pagination onChange={onPagination} total={number} current={current} pageSize={10} />
          </footer>
        </div>
      }
    </Spin>
  )
}
